<script>
export default {
  name: 'App',
};
</script>

<template>
  <div>
    <NuxtLayout>
      <VitePwaManifest />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
